import { LIST_EVENT_RULE, LIST_EVENT_RULE_SUCCESS, LIST_EVENT_RULE_ERROR, LIST_EVENT_RULE_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EventRulesList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EVENT_RULE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LIST_EVENT_RULE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LIST_EVENT_RULE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LIST_EVENT_RULE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EventRulesList;
